/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCopyright = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 2c-4.41 0-8 3.588-8 8s3.59 8 8 8 8-3.588 8-8-3.59-8-8-8zm0 3c1.219 0 2.394.444 3.307 1.25l-1.323 1.5a3 3 0 1 0 .615 3.75l1.732 1.001a5.02 5.02 0 0 1-4.331 2.5c-2.757 0-5-2.244-5-5s2.243-5 5-5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCopyright as Copyright };
